import {AxiosResponse} from 'axios';
import {axiosInstance} from '../..';


export function getVisit(id: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Visit`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getVisitId(id: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Visit/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

